module.exports = __webpack_public_path__ + "static/media/mastercard.64f437b4.png";